import { createContext } from 'react';

export interface ToDoBundleContextProps {
  conversationId: string;
  storeId: string;
  buyerId: string;
  platform: General.PlatformUpperCase;
  externalBuyerId: string;
  assistantId: string;
  region: General.UpperCaseRegion;
  conversation: Conversation.Conversation;
}

export const ToDoBundleContext = createContext<ToDoBundleContextProps>(null!);

export const ReadonlyContext = createContext<boolean>(false);
export const ReadonlyProvider = ReadonlyContext.Provider;
export const ToDoBundleProvider = ToDoBundleContext.Provider;
